import { createReducer, on } from '@ngrx/store';
import { UserConfig, defaultUserConfig } from '@models/user-config.model';
import { UserConfigActions } from '@store/actions/user-config.actions';

export interface UserConfigState {
  userConfig: UserConfig;
}

const initialState: UserConfigState = {
  userConfig: {
    ...defaultUserConfig,
    framesHeight: 160,
  },
};

export const userConfigReducer = createReducer(
  initialState,
  on(UserConfigActions.updateLeftSideContainerWidth, (state, { width }) => ({
    ...state,
    userConfig: {
      ...state.userConfig,
      leftSideContainerWidth: width,
    },
  })),
  on(UserConfigActions.updateRightSideContainerWidth, (state, { width }) => ({
    ...state,
    userConfig: {
      ...state.userConfig,
      rightSideContainerWidth: width,
    },
  })),
  on(UserConfigActions.updateFramesHeight, (state, { height }) => ({
    ...state,
    userConfig: {
      ...state.userConfig,
      framesHeight: height,
    },
  })),
  on(UserConfigActions.setCanvasHintsExpanded, (state, { expanded }) => ({
    ...state,
    userConfig: {
      ...state.userConfig,
      canvasHintsExpanded: expanded,
    },
  })),
  on(UserConfigActions.loadUserConfigSuccess, (state, { userConfig }) => ({
    ...state,
    userConfig,
  }))
);